import styled from 'styled-components';

export const StyledText = styled.p`
  margin: 0;
  color: ${(props) => props.theme.newPalette.neutral.N800};
`;

export const SmallText = styled.p`
  ${(props) => props.theme.newTypography.textStyleBodySmall};
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;

export const TextWrapper = styled.div<{ direction: string }>`
  ${(props) => props.theme.newTypography.textStyleBody};
  display: flex;
  text-align: ${(props) => (props.direction === 'ltr' ? 'left' : 'right')};
`;

export const BoldSpan = styled.strong`
  ${(props) => props.theme.newTypography.textStyleBodySemibold};
`;

export const DividerWrapper = styled.div`
  margin: 30px 0px;
`;

export const DividerContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr 3fr;
`;

export const ButtonContainer = styled.div<{
  reverseOrder: boolean;
  isMobile: boolean;
}>`
  width: 280px;
  ${(props) =>
    props.isMobile ? `position: relative; margin-top: 16px;` : `bottom: 30px;`}
  display: flex;
  flex-direction: ${(props) =>
    props.reverseOrder ? 'column-reverse' : 'column'};
`;
